import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  /** Adds a lift on hover. Use for cards that are links. */
  interactive?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const paddingClasses = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  interactive = false,
  padding = 'md',
}) => {
  const classes = [
    'bg-white rounded-2xl shadow-card border border-gray-100',
    paddingClasses[padding],
    interactive ? 'transition-shadow hover:shadow-card-hover' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <div className={classes}>{children}</div>;
};

export default Card;
